import React, { useState, useRef } from "react";
import {
  NavLink,
  NavLinks,
  NavLinkDropdown,
  DropdownMenu,
  DropdownMenuItem,
  DropdownContainer,
  DropdownMenuInverted,
} from "components/headers/light";

export default ({ inverted = false }) => {
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const timeoutRef = useRef(null);

  const menuItems = [
    { label: "Inicio", href: "/" },
    { label: "¿Quiénes somos?", href: "/quienes-somos" },
    { label: "Papelería", href: "/papeleria" },
    { label: "Trámites Digitales", href: "/tramites-digitales" },
    { label: "Servicios", href: "/servicios" },
    { label: "Contacto", href: "/contacto" },
    {
      label: "Utilidades",
      href: "#",
      hasSubmenu: true,
      submenus: [
        { label: "Plantilla para nombres", href: "/plantilla-nombres" },
        { label: "Calculadora de Comisiones", href: "/calculadora" },
        // más utilidades...
      ],
    },
  ];

  const DropdownMenuComponent = ({ item, isOpen, onClose }) => {
    const handleMouseEnter = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setOpenSubmenu(item.label);
    };

    const handleMouseLeave = () => {
      timeoutRef.current = setTimeout(() => {
        setOpenSubmenu(null);
      }, 100);
    };

    return (
      <DropdownContainer
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <NavLinkDropdown>{item.label} ▼</NavLinkDropdown>

        {isOpen &&
          (inverted ? (
            <DropdownMenuInverted>
              {item.submenus.map((submenu) => (
                <DropdownMenuItem key={submenu.label} href={submenu.href}>
                  {submenu.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenuInverted>
          ) : (
            <DropdownMenu>
              {item.submenus.map((submenu) => (
                <DropdownMenuItem key={submenu.label} href={submenu.href}>
                  {submenu.label}
                </DropdownMenuItem>
              ))}
            </DropdownMenu>
          ))}
      </DropdownContainer>
    );
  };

  return (
    <NavLinks key={1}>
      {menuItems.map((item) =>
        item.hasSubmenu ? (
          <DropdownMenuComponent
            key={item.label}
            item={item}
            isOpen={openSubmenu === item.label}
            onClose={() => setOpenSubmenu(null)}
          />
        ) : (
          <NavLink key={item.label} href={item.href}>
            {item.label}
          </NavLink>
        )
      )}
    </NavLinks>
  );
};
